'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _loadScript = require('load-script');

var _loadScript2 = _interopRequireDefault(_loadScript);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var afterRender = function afterRender(_ref) {
	var props = _ref.props;
	var pubid = props.pubid;


	if (!window.addthis) {
		(0, _loadScript2.default)('https://s7.addthis.com/js/300/addthis_widget.js#pubid=' + pubid);
	}
	if (window.addthis && window.addthis.layers && window.addthis.layers.refresh) {
		setTimeout(window.addthis.layers.refresh(), 500);
	}
}; /** @jsx dom */


var render = function render(_ref2) {
	var id = _ref2.id,
	    props = _ref2.props;
	var gutter = props.gutter,
	    type = props.type,
	    styleClasses = props.styleClasses;

	var container = 'addthis_inline_' + type + '_toolbox';
	var date = new Date().getTime();

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-AddthisSocial', 'CMS-AddthisSocial-' + id, props.class, styleClasses.Social_Buttons], 'data-style-attr': 'Social_Buttons' },
		(0, _magicVirtualElement2.default)(
			'style',
			{ key: date + '-' + gutter },
			'\n\t\t\t\t\t.CMS-AddthisSocial-' + id + ' .at-share-btn-elements .at-share-btn,\n\t\t\t\t\t.CMS-AddthisSocial-' + id + ' .at-follow-tbx-element .at-follow-btn {\n\t\t\t\t\t\tmargin: 0 ' + gutter + 'px;\n\t\t\t\t\t}\n\t\t\t\t'
		),
		(0, _magicVirtualElement2.default)('div', { key: date, 'class': container })
	), props);
};

exports.default = { afterRender: afterRender, render: render };